export default __webpack_public_path__ + "static/media/gem_set_1.663c779a.svg";